export const TASKS_CONTEXT_ACTION_TYPES = {
  SET_SELECTED_TASK: 'set-selected-task',
}

export const initialState = {
  selectedTaskId: null,
}

export function TasksContextReducer(state, action) {
  switch (action.type) {
    case TASKS_CONTEXT_ACTION_TYPES.SET_SELECTED_TASK:
      // Toggle: clicking the same task ID closes the accordion
      return {
        ...state,
        selectedTaskId: state.selectedTaskId === action.taskId ? null : action.taskId,
      }

    default: {
      throw new Error('Unknown action sent to TasksContextReducer: ' + action.type)
    }
  }
}
